export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  BOUNCE_STORAGE_TEST: '__BOUNCE_STORAGE_TEST__',
  ONBOARDED: 'onboarded',
  RECENT_SEARCHES: 'RECENT_SEARCHES',
  COMPLETE_PROFILE_REMINDERS: 'completeProfileReminders',
  HIDE_APP_BANNER: 'HIDE_APP_BANNER'
};
